module.exports = __webpack_public_path__ + "static/img/5.405076b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/5.png
// module id = xMJr
// module chunks = 0